import React from "react";

const blocks = [
  {
    title: "Comment est calculée votre estimation de loyer ?",
    text: "Notre simulateur s'appuie sur les caractéristiques essentielles de votre logement : localisation, surface habitable, nombre de pièces, type de location (vide ou meublée) et prestations comme le balcon, le parking ou l'ascenseur. Ces critères sont rapprochés des loyers pratiqués dans votre secteur pour vous donner une fourchette réaliste, ni surévaluée ni sous-évaluée. Un loyer bien positionné, c'est un bien loué plus vite et un locataire qui reste plus longtemps.",
  },
  {
    title: "Encadrement des loyers : un point à vérifier à Paris",
    text: "À Paris et dans plusieurs communes d'Île-de-France, le loyer de base ne peut pas dépasser un loyer de référence majoré fixé par arrêté préfectoral, selon le quartier, l'époque de construction, le nombre de pièces et le type de location. Un complément de loyer n'est possible que pour des caractéristiques exceptionnelles du logement. Lors de la mise en location, votre gestionnaire Loyaris contrôle ce plafond pour sécuriser votre bail et éviter toute contestation ultérieure du locataire.",
  },
  {
    title: "Frais de gestion : ce que vous payez vraiment",
    text: "Les honoraires de gestion sont calculés en pourcentage des sommes réellement encaissées, charges comprises. Avec la Formule Liberté à 3,60 % TTC, vous confiez l'essentiel : quittancement, encaissement, reversement, compte rendu mensuel et révision du loyer. La Formule Sérénité à 4,20 % TTC ajoute la régularisation des charges, le paiement des appels de fonds du syndic, le suivi des travaux et la pré-déclaration des revenus fonciers. Les honoraires de gestion sont, sous conditions, déductibles de vos revenus fonciers au régime réel.",
  },
  {
    title: "Protéger vos revenus avec l'assurance loyers impayés",
    text: "Pour 2,10 % des loyers encaissés, l'option garantie loyers impayés souscrite auprès de MMA Assurances couvre les loyers et charges impayés, sans franchise ni délai de carence, ainsi que les frais de procédure. C'est la meilleure façon de transformer une estimation de loyer en revenu réellement perçu, mois après mois.",
  },
  {
    title: "Et après l'estimation ?",
    text: "Une fois votre estimation obtenue, un gestionnaire Loyaris peut affiner le montant lors d'un échange, en tenant compte de l'état du bien, de sa luminosité ou de son exposition. Il vous accompagne ensuite de la mise en location jusqu'à la gestion courante, avec un interlocuteur unique et un espace client en ligne pour suivre vos loyers en temps réel.",
  },
];

export default function EstimationGuide() {
  return (
    <section data-testid="estimation-guide" className="bg-[#FBF9F5] py-20 lg:py-24">
      <div className="mx-auto max-w-[920px] px-5 lg:px-8">
        <p className="mb-3 flex items-center gap-3 text-[12px] font-semibold uppercase tracking-[0.2em] text-[#B08D57]">
          <span className="h-px w-8 bg-[#B08D57]" /> Guide du propriétaire
        </p>
        <h2 className="font-serifDisplay text-[30px] leading-tight text-[#26241F] lg:text-[40px]">
          Bien estimer son loyer et ses frais de gestion locative
        </h2>
        <div className="mt-10 space-y-10">
          {blocks.map((b) => (
            <article key={b.title}>
              <h3 className="text-[19px] font-semibold text-[#26241F]">{b.title}</h3>
              <p className="mt-3 text-[16px] leading-relaxed text-[#6e6a62]">{b.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
